/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Downloads_Web_AppInputs */

const en_downloads_web_app = /** @type {(inputs: Downloads_Web_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open Web App`)
};

const es_downloads_web_app = /** @type {(inputs: Downloads_Web_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir app web`)
};

/**
* | output |
* | --- |
* | "Open Web App" |
*
* @param {Downloads_Web_AppInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const downloads_web_app = /** @type {((inputs?: Downloads_Web_AppInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Downloads_Web_AppInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_downloads_web_app(inputs)
	return en_downloads_web_app(inputs)
});